// import AppConstants from "../../../../../config/app.constants";

import TNTBillingBase from "../../util/TNTBillingBase";

class BillableEventsController extends TNTBillingBase{
  /*@ngInject*/
  constructor($state) {
    super();
    this.$state = $state;
    this.acl = {};
    this.hasACL = {};
    this.id = 'billable_events'
  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_billing_' + this.id]) {
        this.hasACL[this.acl['tnt_billing_' + this.id][key]] = true;
    }
  }	
}

export default BillableEventsController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/billable_events.controller.js